import React, { useEffect, useState } from 'react';
import { Phone } from 'lucide-react';
import { PHONE_HREF } from '../mock';

export default function StickyCall() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <a
      href={PHONE_HREF}
      className={`fixed bottom-5 right-5 z-50 btn-accent flex items-center gap-3 rounded-md px-5 py-4 label-mono tracking-[0.14em] text-[0.72rem] shadow-2xl transition-all duration-500 ${
        show ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6 pointer-events-none'
      }`}
    >
      <span className="w-2 h-2 rounded-full bg-white pulse-dot" />
      <Phone size={14} strokeWidth={2.4} />
      <span className="hidden sm:inline">Emergency Callout · Tap to Ring</span>
      <span className="sm:hidden">Tap to Ring</span>
    </a>
  );
}
